var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ma-modal",
    {
      ref: "linkMoreInfoModal",
      staticClass: "modal-link",
      attrs: { type: "medium" },
      on: { "modal:close": _vm.close }
    },
    [
      _c("template", { slot: "modalContent" }, [
        _c("div", { staticClass: "more_info_modal__main" }, [
          _c("div", { staticClass: "container-content_modal" }, [
            _c("p", { staticClass: "black headline-large mg mg--b-4" }, [
              _c("span", [
                _vm._v(_vm._s(_vm.$t("warrantyProps.moreInfoModal.title")))
              ]),
              _vm.stateWarrantySinisterId
                ? _c("span", [_vm._v(_vm._s(_vm.sinisterId))])
                : _vm._e()
            ]),
            _c("p", { staticClass: "headline-medium blueDark mg mg--b-3" }, [
              _vm._v(
                _vm._s(_vm.$t("warrantyProps.moreInfoModal.personalInfo.title"))
              )
            ]),
            _c(
              "div",
              { staticClass: "grid" },
              [
                _c("ma-input-text", {
                  attrs: {
                    name: "moreInfoName",
                    icon: "ico-donnes-du-dossier",
                    col: "2",
                    literal: _vm.$t(
                      "warrantyProps.moreInfoModal.personalInfo.name"
                    ),
                    value: _vm.stateComWarrantyName
                  },
                  on: {
                    change: function($event) {
                      ;[
                        (_vm.stateComWarrantyName = $event),
                        _vm.actWarrantyUpdateProps()
                      ]
                    }
                  }
                }),
                _c("ma-input-text", {
                  attrs: {
                    name: "moreInfoSurname",
                    icon: "ico-donnes-du-dossier",
                    col: "2",
                    literal: _vm.$t(
                      "warrantyProps.moreInfoModal.personalInfo.surname"
                    ),
                    value: _vm.stateComWarrantySurname
                  },
                  on: {
                    change: function($event) {
                      ;[
                        (_vm.stateComWarrantySurname = $event),
                        _vm.actWarrantyUpdateProps()
                      ]
                    }
                  }
                }),
                _c("ma-input-text", {
                  attrs: {
                    name: "moreInfoEmail",
                    icon: "globe",
                    col: "2",
                    literal: _vm.$t(
                      "warrantyProps.moreInfoModal.personalInfo.email"
                    ),
                    value: _vm.stateComWarrantyEmail
                  },
                  on: {
                    change: function($event) {
                      ;[
                        (_vm.stateComWarrantyEmail = $event),
                        _vm.actWarrantyUpdateProps()
                      ]
                    }
                  }
                }),
                _c("ma-input-radio", {
                  attrs: {
                    value: _vm.stateComWarrantySinisterAddress,
                    type: "radio",
                    name: "sinisterAddress",
                    options: _vm.validContractOptions,
                    literal: _vm.$t(
                      "warrantyProps.moreInfoModal.personalInfo.sinisterAddress"
                    ),
                    col: "1",
                    selectFirst: false
                  },
                  on: {
                    change: function($event) {
                      ;[
                        (_vm.stateComWarrantySinisterAddress = $event),
                        _vm.actWarrantyUpdateProps()
                      ]
                    }
                  }
                })
              ],
              1
            ),
            _c(
              "p",
              { staticClass: "headline-medium blueDark mg mg--b-3 mg--t-3" },
              [
                _vm._v(
                  _vm._s(
                    _vm.$t("warrantyProps.moreInfoModal.contractInfo.title")
                  )
                )
              ]
            ),
            _c(
              "div",
              { staticClass: "grid__row" },
              [
                _c("ma-date-picker", {
                  staticClass: "input-date mg grid__cell-md-1",
                  attrs: {
                    type: "range",
                    icon: "calendar",
                    literal: _vm.$t(
                      "warrantyProps.moreInfoModal.contractInfo.date"
                    ),
                    handleChangeInput: _vm.handleChangeSinisterDate,
                    defaultValue: _vm.dateSelected,
                    dateMax: _vm.maxDate,
                    format: _vm.dateFormat,
                    col: "1"
                  }
                }),
                _c("ma-input-radio", {
                  attrs: {
                    name: "moreInfoValidateContract",
                    literal: _vm.$t(
                      "warrantyProps.moreInfoModal.contractInfo.isValid"
                    ),
                    options: _vm.validContractOptions,
                    value: _vm.stateComWarrantyValidateContract,
                    col: "1",
                    type: "radio",
                    selectFirst: false
                  },
                  on: {
                    change: function($event) {
                      ;[
                        (_vm.stateComWarrantyValidateContract = $event),
                        _vm.actWarrantyUpdateProps()
                      ]
                    }
                  }
                }),
                _c("ma-input-radio", {
                  attrs: {
                    value: _vm.stateComWarrantyScoreAsk,
                    type: "radio",
                    name: "moreInfoScoreAsk",
                    options: _vm.scoreAskOptions,
                    literal: _vm.$t(
                      "warrantyProps.moreInfoModal.contractInfo.scoreAsk"
                    ),
                    col: "1",
                    selectFirst: false
                  },
                  on: {
                    change: function($event) {
                      ;[
                        (_vm.stateComWarrantyScoreAsk = $event),
                        _vm.actWarrantyUpdateProps()
                      ]
                    }
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "grid__row grid--jc-between" },
              [
                _c("ma-input-radio", {
                  attrs: {
                    name: "franchiseGenerale",
                    col: "2",
                    type: "radio",
                    options: _vm.franchiseOptions,
                    literal: _vm.$t(
                      "warrantyProps.moreInfoModal.contractInfo.franchiseGenerale"
                    ),
                    value: _vm.stateComWarrantyInmobiliere,
                    selectFirst: false
                  },
                  on: {
                    change: function($event) {
                      ;[
                        (_vm.stateComWarrantyInmobiliere = $event),
                        _vm.actWarrantyUpdateProps()
                      ]
                    }
                  }
                }),
                _c("ma-input-radio", {
                  attrs: {
                    name: "franchiseInondation",
                    col: "1",
                    type: "radio",
                    options: _vm.franchiseInondationOptions,
                    literal: _vm.$t(
                      "warrantyProps.moreInfoModal.contractInfo.franchiseInondation"
                    ),
                    value: _vm.stateComWarrantyEmbellissement,
                    selectFirst: false
                  },
                  on: {
                    change: function($event) {
                      ;[
                        (_vm.stateComWarrantyEmbellissement = $event),
                        _vm.actWarrantyUpdateProps()
                      ]
                    }
                  }
                }),
                _c("ma-input-checkbox", {
                  attrs: {
                    name: "franchiseEgout",
                    col: "1",
                    type: "checkbox",
                    options: _vm.franchiseEgoutOptions,
                    literal: _vm.$t(
                      "warrantyProps.moreInfoModal.contractInfo.franchiseEgout"
                    ),
                    value: _vm.stateComWarrantyMobilier
                  },
                  on: {
                    change: function($event) {
                      ;[
                        _vm.onFranchiseEgoutChange($event),
                        _vm.actWarrantyUpdateProps()
                      ]
                    }
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "grid__row" },
              [
                _c("ma-input-checkbox", {
                  attrs: {
                    value: _vm.stateComWarrantyPiscine,
                    type: "checkbox",
                    name: "moreInfoPiscine",
                    options: _vm.piscineOptions,
                    literal: _vm.$t(
                      "warrantyProps.moreInfoModal.contractInfo.swimmingPool"
                    ),
                    col: "1"
                  },
                  on: {
                    change: function($event) {
                      ;[
                        _vm.onPiscineChange($event),
                        _vm.actWarrantyUpdateProps()
                      ]
                    }
                  }
                }),
                _c("ma-input-checkbox", {
                  attrs: {
                    value: _vm.stateComWarrantyExterieur,
                    type: "checkbox",
                    name: "moreInfoExterieur",
                    options: _vm.externalOptions,
                    literal: _vm.$t(
                      "warrantyProps.moreInfoModal.contractInfo.externalFittings"
                    ),
                    col: "1"
                  },
                  on: {
                    change: function($event) {
                      ;[
                        _vm.onExterieurChange($event),
                        _vm.actWarrantyUpdateProps()
                      ]
                    }
                  }
                })
              ],
              1
            ),
            _c("p"),
            _c(
              "p",
              { staticClass: "headline-medium blueDark mg mg--b-3 mg--t-3" },
              [
                _vm._v(
                  _vm._s(
                    _vm.$t("warrantyProps.moreInfoModal.verifications.title")
                  )
                )
              ]
            ),
            _c(
              "div",
              { staticClass: "grid__row" },
              [
                _c("ma-input-radio", {
                  attrs: {
                    value: _vm.stateComWarrantyCurrentClaim,
                    type: "radio",
                    name: "moreInfoCurrentClaim",
                    options: _vm.validContractOptions,
                    literal: _vm.$t(
                      "warrantyProps.moreInfoModal.verifications.beforeSinister"
                    ),
                    textTooltip: _vm.$t(
                      "warrantyProps.moreInfoModal.verifications.beforeSinisterTooltip"
                    ),
                    showTooltip: "",
                    col: "1",
                    selectFirst: false
                  },
                  on: {
                    change: function($event) {
                      ;[
                        (_vm.stateComWarrantyCurrentClaim = $event),
                        _vm.actWarrantyUpdateProps()
                      ]
                    }
                  }
                }),
                _c("ma-input-radio", {
                  attrs: {
                    value: _vm.stateComWarrantyLitigationAlertAbsence,
                    type: "radio",
                    name: "litigationAlertAbsence",
                    options: _vm.validContractOptions,
                    literal: _vm.$t(
                      "warrantyProps.moreInfoModal.verifications.litigationAlertAbsence"
                    ),
                    col: "1",
                    selectFirst: false
                  },
                  on: {
                    change: function($event) {
                      ;[
                        (_vm.stateComWarrantyLitigationAlertAbsence = $event),
                        _vm.actWarrantyUpdateProps()
                      ]
                    }
                  }
                }),
                _c("ma-counter", {
                  attrs: {
                    name: "moreInfoGaGNumber",
                    value: _vm.stateComWarrantyGagNumber,
                    literal: _vm.$t(
                      "warrantyProps.moreInfoModal.verifications.GaG"
                    ),
                    textTooltip: _vm.$t(
                      "warrantyProps.moreInfoModal.verifications.indemnityName"
                    ),
                    noMargin: "",
                    fullSize: "",
                    col: 1
                  },
                  on: {
                    newValue: function($event) {
                      ;[
                        (_vm.stateComWarrantyGagNumber = $event),
                        _vm.actWarrantyUpdateProps()
                      ]
                    }
                  }
                }),
                _c("ma-counter", {
                  attrs: {
                    name: "moreInfoRenNumber",
                    literal: _vm.$t(
                      "warrantyProps.moreInfoModal.verifications.ren"
                    ),
                    value: _vm.stateComWarrantyRenNumber,
                    textTooltip: _vm.$t(
                      "warrantyProps.moreInfoModal.verifications.indemnityName"
                    ),
                    noMargin: "",
                    fullSize: "",
                    col: 1
                  },
                  on: {
                    newValue: function($event) {
                      ;[
                        (_vm.stateComWarrantyRenNumber = $event),
                        _vm.actWarrantyUpdateProps()
                      ]
                    }
                  }
                })
              ],
              1
            ),
            _c("p"),
            _c(
              "p",
              { staticClass: "headline-medium blueDark mg mg--b-3 mg--t-3" },
              [
                _vm._v(
                  _vm._s(
                    _vm.$t("warrantyProps.moreInfoModal.sinisterCause.title")
                  )
                )
              ]
            ),
            _c(
              "div",
              { staticClass: "grid__row" },
              [
                _c("ma-input-btn", {
                  staticClass: "radio-image",
                  attrs: {
                    type: "radio",
                    name: "moreInfoSinisterCause",
                    col: "2",
                    buttonContentClass: "image-radio-content",
                    literal: _vm.$t(
                      "warrantyProps.moreInfoModal.sinisterCause.cause"
                    ),
                    options: _vm.moreInfoSinisterCauseOptions,
                    value: _vm.stateComWarrantySinisterCause
                  },
                  on: {
                    change: function($event) {
                      ;[
                        (_vm.stateComWarrantySinisterCause = $event),
                        _vm.actWarrantyUpdateProps()
                      ]
                    }
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "grid__row" },
              [
                _c("ma-input-radio", {
                  attrs: {
                    value: _vm.stateComWarrantySinisterPlace,
                    type: "radio",
                    name: "sinisterPlace",
                    options: _vm.sinisterPlaceOptions,
                    literal: _vm.$t(
                      "warrantyProps.moreInfoModal.sinisterCause.sinisterPlace"
                    ),
                    col: "1",
                    selectFirst: false
                  },
                  on: {
                    change: function($event) {
                      ;[
                        (_vm.stateComWarrantySinisterPlace = $event),
                        _vm.actWarrantyUpdateProps()
                      ]
                    }
                  }
                }),
                _c("ma-input-radio", {
                  attrs: {
                    value: _vm.stateComWarrantyDamagePlace,
                    type: "radio",
                    name: "damagePlace",
                    options: _vm.damagePlaceOptions,
                    literal: _vm.$t(
                      "warrantyProps.moreInfoModal.sinisterCause.damagePlace"
                    ),
                    col: "1",
                    selectFirst: false
                  },
                  on: {
                    change: function($event) {
                      ;[
                        (_vm.stateComWarrantyDamagePlace = $event),
                        _vm.actWarrantyUpdateProps()
                      ]
                    }
                  }
                }),
                _c("ma-input-radio", {
                  attrs: {
                    value: _vm.stateComWarrantyCauseRepaired,
                    type: "radio",
                    name: "causeRepaired",
                    options: _vm.causeRepairedOptions,
                    literal: _vm.$t(
                      "warrantyProps.moreInfoModal.sinisterCause.causeRepaired"
                    ),
                    col: "1",
                    selectFirst: false
                  },
                  on: {
                    change: function($event) {
                      ;[
                        (_vm.stateComWarrantyCauseRepaired = $event),
                        _vm.actWarrantyUpdateProps()
                      ]
                    }
                  }
                }),
                _c("ma-input-radio", {
                  attrs: {
                    value: _vm.stateComWarrantyThirdPartyInvolved,
                    type: "radio",
                    name: "thirdPartyInvolved",
                    options: _vm.validContractOptions,
                    literal: _vm.$t(
                      "warrantyProps.moreInfoModal.sinisterCause.thirdPartyInvolved"
                    ),
                    col: "1",
                    selectFirst: false
                  },
                  on: {
                    change: function($event) {
                      ;[
                        (_vm.stateComWarrantyThirdPartyInvolved = $event),
                        _vm.actWarrantyUpdateProps()
                      ]
                    }
                  }
                })
              ],
              1
            ),
            _c("p"),
            _c(
              "button",
              {
                staticClass: "btn mainBlue grid__cell-md-4 mg mg--r-2 mg--t-2",
                attrs: { disabled: !_vm.isMoreInfoSendButtonEnabled },
                on: { click: _vm.sendAditionalInfo }
              },
              [_vm._v(_vm._s(_vm.$t("warrantyProps.moreInfoModal.send")))]
            )
          ])
        ])
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }